'use client';

import { createContext, useContext, type ReactNode } from 'react';

type SportsbookRouteCompetition = {
  slug: string;
  championshipIds: number[];
};

type SportsbookRouteCategory = {
  slug: string;
  sportId: number;
  competitions: SportsbookRouteCompetition[];
};

const SportsbookRoutesContext = createContext<SportsbookRouteCategory[]>([]);

function SportsbookRoutesProvider({ categories, children }: { categories: SportsbookRouteCategory[]; children: ReactNode }) {
  return <SportsbookRoutesContext.Provider value={categories}>{children}</SportsbookRoutesContext.Provider>;
}

function useSportsbookRoutes(): SportsbookRouteCategory[] {
  return useContext(SportsbookRoutesContext);
}

export { SportsbookRoutesProvider, useSportsbookRoutes };
export type { SportsbookRouteCategory, SportsbookRouteCompetition };
